module.exports = __webpack_public_path__ + "img/logo_title_2.cd000e94.png";